export const ROWSIZE = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    PATH_CHART: 'path-chart',
};

export const ROWHEIGHT = {
    [ROWSIZE.SMALL]: 32,
    [ROWSIZE.MEDIUM]: 46,
    [ROWSIZE.LARGE]: 64,
    [ROWSIZE.PATH_CHART]: 540,
};

export const ROWWIDTH = {
    MIN: 150,
    MAX: 400,
    STATUS_TREND_MIN: 340,
};

export const ROWCLASS = {
    [ROWSIZE.SMALL]: 'rowsize-small',
    [ROWSIZE.MEDIUM]: 'rowsize-medium',
    [ROWSIZE.LARGE]: 'rowsize-large',
    [ROWSIZE.PATH_CHART]: 'rowsize-path-chart',
};

export const SIZED_CELL_CLASS = 'datatable-sized-cell';
export const INNER_CELL_VALUE_CLASS = 'datatable-inner-cell-value';

// These are used for selenium tests. They should not be used for styling.
export const DATATABLE_CLASS = 'datatable';
export const DATATABLE_ROW_CLASS = 'datatable-row';
export const DATATABLE_CELL_CLASS = 'datatable-cell';
export const DATATABLE_ROWSTATUS_CLASS = 'datatable-rowstatus';
